import styled from 'styled-components'

const StyledEditorMediaList = styled.div`
  display: grid;
  gap: 0;
  margin: -8px 0 0 0;
`

export default StyledEditorMediaList
